// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c_D1","newExpiryDate":"styles_newExpiryDate__2y_Ar","footer":"styles_footer__282nM"};